import { render, staticRenderFns } from "./CiclosEsterilizacao.vue?vue&type=template&id=42b4c57d&scoped=true&"
import script from "./CiclosEsterilizacao.vue?vue&type=script&lang=js&"
export * from "./CiclosEsterilizacao.vue?vue&type=script&lang=js&"
import style0 from "./CiclosEsterilizacao.vue?vue&type=style&index=0&id=42b4c57d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b4c57d",
  null
  
)

export default component.exports